import { HttpClient, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, resource } from '@angular/core';
import { lastValueFrom, map, of } from 'rxjs';
import { Option } from '../../models/common.models';
import { SalesChannelResponse } from '../../models/sales-channel.model';
import { RegionService } from '../region/region.service';
import { mapSalesChannelResponseToModel } from './sales-channel.mapper';

@Injectable({
  providedIn: 'root',
})
export class SalesChannelService {
  private readonly http = inject(HttpClient);
  private readonly regions = inject(RegionService);

  private readonly salesChannels$ = (regionId?: number) => {
    if (!regionId) {
      return of([]);
    }

    return this.http
      .get<SalesChannelResponse[]>(`saleschannel/region/${regionId}`)
      .pipe(
        map((channels) =>
          channels.map((response) => mapSalesChannelResponseToModel(response)),
        ),
      );
  };

  salesChannels = resource({
    params: () => this.regions.selectedRegionId(),
    loader: ({ params }) => lastValueFrom(this.salesChannels$(params)),
    defaultValue: [],
  });

  salesChannelOptions = computed<Option[]>(() =>
    this.salesChannels
      .value()
      .map((channel) => ({ label: channel.name, value: channel.code })),
  );

  syncSalesChannel(channelCode: string) {
    const params = new HttpParams().set('channelcode', channelCode);

    return this.http.post(
      'inventory/sync-saleschannel',
      {},
      {
        params,
      },
    );
  }

  getSalesChannelsByRegionId(regionId: number) {
    return this.http
      .get<SalesChannelResponse[]>(`saleschannel/region/${regionId}`)
      .pipe(
        map((channels) =>
          channels.map((response) => mapSalesChannelResponseToModel(response)),
        ),
      );
  }
}
